import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { useMemo } from 'react';
import { useResumeWatching } from './useResumeWatching';

export const useVideoProgressPosition = (assetId?: string, locale?: string) => {
  const { viewingProgress, isLoadingViewingProgress } =
    useResumeWatching(locale);

  return useMemo(() => {
    if (!assetId) return { isLoadingViewingProgress, progress: 0 };

    // extend dayjs with duration plugin
    dayjs.extend(duration);

    const position = viewingProgress?.find(
      (progress) => progress.assetId === assetId,
    )?.progress?.position;
    if (!position) return { isLoadingViewingProgress, progress: 0 };
    return {
      isLoadingViewingProgress,
      progress: dayjs.duration(position).asSeconds(),
    };
  }, [assetId, viewingProgress, isLoadingViewingProgress]);
};
